import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Ink from 'react-ink';
import { toast } from 'react-toastify';

import * as ClaimHomeActions from './ClaimHomeActions';
import ReactGA from 'react-ga';

import './Style';

class ClaimHomeContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            error: null,
            errorInfo: null,
            toastId: null
        }

      this.claimHomeBtnClick = this.claimHomeBtnClick.bind(this);
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.error) {
            if (!toast.isActive(this.state.toastId)) {
                this.setState({
                    toastId: toast.error('Can\'t fetch the tour data')
                });
            }
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    claimHomeBtnClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'claim home'
        // });
        this.props.claimHomeActions.getClaimHomeData();
    }

    render() {
        const { url } = this.props;
        const { error } = this.state;

        if (!url || error) {
            return null;
        }

        return (
            <div id="claimHome" className="claimHome-component">
                <div className="claimHome-content">
                    <h4>Bought this Home? Claim it to unlock its HomeDiary.</h4>
                    <p>
                        Get exclusive access to the photos, floor plans, and 3D space planner, all in
                        your own private HomeDiary account. Use it to plan spaces, ideas,
                        and even log paint colors, receipts, and more.
                    </p>
                    <button className="btn" target="_blank" onClick={this.claimHomeBtnClick}>
                        claim home
                        <Ink />
                    </button>
                </div>
            </div>
        )
    }
}

ClaimHomeContainer.propTypes = {
    error: PropTypes.string.isRequired
}

const mapStateToProps = (state) => ({
    error: state.claimHome.error,
    url: state.claimHome.url
})

const mapDispatchToProps = (dispatch) => ({
    claimHomeActions: bindActionCreators(ClaimHomeActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ClaimHomeContainer)
